"use strict";

exports.__esModule = true;
exports.getTooltip = exports.UtilizationSummaryDataFormatter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _BarChart = require("../../common/AggregateMetricCharts/BarChart");
var _StackedBar = require("../../common/AggregateMetricCharts/StackedBar");
var _stateDetails = require("../stateDetails");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _UtilizationChartDataFormatter = require("../UtilizationChartDataFormatter");
var _core = require("@blueprintjs/core");
var _Metrics = require("../../../../Catalogs/Metrics");
var _tooltipSort = require("../../common/tooltipSort");
var _whenModern = require("../../../Theme/UiDesign/whenModern");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TooltipTable = _styledComponents["default"].table.withConfig({
  displayName: "UtilizationSummaryDataFormatter__TooltipTable",
  componentId: "sc-163z2q5-0"
})(["background:", ";min-width:200px;text-align:left;border-spacing:0;border-collapse:collapse;font-size:12px;"], function (props) {
  return props.theme.primaryBackgroundColor;
});
var TooltipRow = _styledComponents["default"].tr.withConfig({
  displayName: "UtilizationSummaryDataFormatter__TooltipRow",
  componentId: "sc-163z2q5-1"
})(["height:12px;margin:0;padding:0;"]);
var TooltipCell = _styledComponents["default"].td.withConfig({
  displayName: "UtilizationSummaryDataFormatter__TooltipCell",
  componentId: "sc-163z2q5-2"
})(["margin:0;padding:2px;border-bottom:", ";text-align:", ";width:", "px;"], function (props) {
  return "1px solid " + props.theme.borderColor;
}, function (props) {
  return props.align;
}, function (props) {
  return props.width;
});
var ColorBlock = _styledComponents["default"].div.withConfig({
  displayName: "UtilizationSummaryDataFormatter__ColorBlock",
  componentId: "sc-163z2q5-3"
})(["background:", ";", " margin:0px;"], function (props) {
  return props.color;
}, (0, _whenModern.whenModern)((0, _styledComponents.css)(["width:9px;height:9px;border-radius:2px;"]), (0, _styledComponents.css)(["width:12px;height:12px;"])));
var TextValue = _styledComponents["default"].span.withConfig({
  displayName: "UtilizationSummaryDataFormatter__TextValue",
  componentId: "sc-163z2q5-4"
})(["color:", ";font-weight:", ";margin:0;padding:0 2px;line-height:10px;"], function (props) {
  return props.theme.primaryTextColor;
}, function (props) {
  return props.bold ? "bold" : "normal";
});
var Value = (0, _styledComponents["default"])(TextValue).withConfig({
  displayName: "UtilizationSummaryDataFormatter__Value",
  componentId: "sc-163z2q5-5"
})(["margin-right:4px;"]);
var getTooltip = exports.getTooltip = function getTooltip(devices, tooltipSort) {
  if (tooltipSort === void 0) {
    tooltipSort = _tooltipSort.TOOLTIP_SORT_DESC;
  }
  return function (item) {
    var states = (0, _tooltipSort.sortTooltipItems)(item.value, _stateDetails.stateDetails, tooltipSort);
    return /*#__PURE__*/_react["default"].createElement(TooltipTable, {
      "data-testid": "UtilizationChart.Tooltip"
    }, (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement("thead", {
      "data-testid": "UtilizationChart.Tooltip.header"
    }, /*#__PURE__*/_react["default"].createElement(TooltipRow, null, /*#__PURE__*/_react["default"].createElement(TooltipCell, {
      align: "left",
      width: 15
    }), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
      align: "left",
      width: 130
    }, /*#__PURE__*/_react["default"].createElement(TextValue, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "Tooltip.totalOfDevices",
      defaultMessage: "Total devices selected"
    }))), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
      align: "right",
      width: 30
    }), /*#__PURE__*/_react["default"].createElement(TooltipCell, null), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
      align: "right",
      width: 15
    }, /*#__PURE__*/_react["default"].createElement(Value, {
      bold: true
    }, "" + devices.length.toFixed(0))))), /*#__PURE__*/_react["default"].createElement("tbody", null, states.map(function (state) {
      var stateData = _stateDetails.stateDetails.find(function (v) {
        return v.key === state.key;
      });
      return /*#__PURE__*/_react["default"].createElement(TooltipRow, {
        key: state.key,
        "data-testid": "UtilizationChart.Tooltip.row." + state.key
      }, /*#__PURE__*/_react["default"].createElement(TooltipCell, {
        align: "left",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(ColorBlock, {
        color: stateData && stateData.color
      })), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
        align: "left",
        width: 130
      }, /*#__PURE__*/_react["default"].createElement(TextValue, null, stateData && stateData.name)), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
        align: "right",
        width: 30
      }, /*#__PURE__*/_react["default"].createElement(Value, {
        bold: true
      }, state.value.toFixed(2) + "%")), /*#__PURE__*/_react["default"].createElement(TooltipCell, {
        align: "left"
      }, /*#__PURE__*/_react["default"].createElement(TextValue, {
        bold: true
      }, (0, _UtilizationChartDataFormatter.getFormattedValue)("MILLISECOND", state.duration))), (devices == null ? void 0 : devices.length) > 1 && /*#__PURE__*/_react["default"].createElement(TooltipCell, {
        align: "right",
        width: 15
      }, /*#__PURE__*/_react["default"].createElement(Value, {
        bold: true
      }, "" + state.devices.length.toFixed(0))));
    })));
  };
};
var createSeries = function createSeries(_ref) {
  var data = _ref.data,
    selectedStates = _ref.selectedStates,
    devices = _ref.devices,
    _ref$tooltipSort = _ref.tooltipSort,
    tooltipSort = _ref$tooltipSort === void 0 ? _tooltipSort.TOOLTIP_SORT_DESC : _ref$tooltipSort;
  data = data.reduce(function (states, doc) {
    var state = doc.state;
    if (!states[state]) {
      var _Object$assign;
      return Object.assign({}, states, (_Object$assign = {}, _Object$assign[state] = {
        key: state,
        value: doc["duration_sum"],
        devices: [doc["device"]]
      }, _Object$assign));
    }
    states[state].value += doc["duration_sum"];
    states[state].devices.push(doc["device"]);
    return states;
  }, {});
  data = Object.values(data);
  var totalOfStates = data.reduce(function (acc, _ref2) {
    var value = _ref2.value;
    return acc += value;
  }, 0) || 1;
  var allStatesData = (0, _UtilizationChartDataFormatter.enrichAndArrangeState)(data);
  allStatesData = allStatesData.map(function (item) {
    return {
      key: item.key,
      value: item.value * 100 / totalOfStates,
      duration: item.value,
      devices: item.devices
    };
  });
  var selectedStatesData = (0, _tooltipSort.sortTooltipItems)(allStatesData.filter(function (v) {
    return selectedStates.includes(v.key);
  }), _stateDetails.stateDetails, tooltipSort);
  var seriesData = [{
    key: "",
    value: selectedStatesData,
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_StackedBar.StackedBar, props);
    }
  }];
  var metric = (0, _Metrics.getMetricDefinition)("utilization");
  return [{
    metricName: metric.name,
    data: seriesData,
    unit: metric.units,
    color: metric.color,
    getXValue: function getXValue(item) {
      return item.key;
    },
    getYValue: function getYValue(item) {
      return item.value;
    },
    getTooltip: getTooltip(devices, tooltipSort),
    toolTipPosition: _core.Position.LEFT,
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_BarChart.BarChart, props);
    }
  }];
};
var UtilizationSummaryDataFormatter = exports.UtilizationSummaryDataFormatter = function UtilizationSummaryDataFormatter(props) {
  var series = createSeries(props);
  return props.children({
    series: series
  });
};